import debounce from 'lodash/debounce';
import React from 'react';

import { PAGE_HEIGHT } from '@xing-com/crate-lebenslauf-constants';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const useScale = (element: React.RefObject<HTMLDivElement>): number => {
  const [scale, setScale] = React.useState(0);
  const { showAnschreibenBanner } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const updateDimensions = (): void => {
      if (element?.current) {
        setScale(element.current.offsetHeight / PAGE_HEIGHT);
      }
    };
    const debouncedHandleResize = debounce(() => {
      updateDimensions();
    }, 250);

    updateDimensions();

    window.addEventListener('resize', debouncedHandleResize);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [showAnschreibenBanner]);

  return scale;
};
